<script>
    import { info } from '../store';
    import Step5 from './Step5.svelte';
    import Step7 from './Step7.svelte';

    export let step;
    export let stepComponent;

    function paySmallestCredit () {
        $info.payment_option_credit = 'smallest_credit';
        step = 7;
        stepComponent = Step7;
    }

    function payBiggestInterest () {
        $info.payment_option_credit = 'biggest_interest';
        step = 7;
        stepComponent = Step7;
    }

    function prev () {
        step = 5;
        stepComponent = Step5;
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-6">
        <div class="text-center color-mov mb-4">
            <h2>Ce datorie plătești mai întâi?</h2>
        </div>

        <div class="container-700 text-center">
            <p>Alegi și în funcție de ce ai ales se face sortarea datoriilor după principal (suma imprumutata) sau dupa rata dobânzii si se platesc intai fie datoria cea mai mica, fie datoria cu rata dobanzii cea mai ridicata.</p>

            <div class="text-center color-orange mb-4">
                <h2>Ai de făcut o alegere.</h2>
            </div>

            <div class="row">
                <div class="col-lg-6 text-center">
                    <p>Plătești în avans datoria cea mai mică (80% din oamenii care practică această metodă reușesc să o ducă la bun sfârșit)</p>
                    <button class="buton bt-next-step" on:click="{paySmallestCredit}">Aleg datoria cea mai mică</button>
                </div>
                <div class="col-lg-6 text-center">
                    <p>Plătești în avans datoria cu rata dobânzii cea mai mare (funcționează și aceasta, dar cu o rată mai mică de succes)</p>
                    <button class="buton bt-next-step" on:click="{payBiggestInterest}">Aleg dobânda cea mai mare</button>
                </div>
            </div>
        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{prev}">
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
